<template>
  <div :class="['content', { 'content-en': !iscn }]" ref="content">
    <div class="wrap">
      <div v-if="iscn" class="title">拯救世界，从转转做起!</div>
      <div v-else class="title">
        To save the world,<br/>
        let's start with ourselves!
      </div>
      <div v-if="iscn" class="sub-title">“表面功夫”不能少？包装也要可持续！</div>
      <div v-else class="sub-title">
        We integrate sustainability into our product packages.
      </div>
      <div class="package">
        <img v-if="iscn" src="../assets/model-info1-1.png" class="package-item" alt="">
        <img v-else src="../assets/model-info1-1-en.png" class="package-item package-item-en" alt="">
        <img v-if="iscn" src="../assets/model-info1-2.png" class="package-item" alt="">
        <img v-else src="../assets/model-info1-2-en.png" class="package-item package-item-en" alt="">
      </div>
      <div class="activity">
        <!-- <div class="activity-wrap">
          <img v-for="item in 3" :key="item" src="../assets/model-info1-9.png" alt="" class="activity-icon">
        </div> -->
        <div class="activity-wrap activity-wrap-content">
          <div :class="['activity-item-wrap', { 'activity-item-wrap-en': !iscn }]">
            <img src="../assets/model-info1-9.png" alt="" class="activity-icon">
            <div class="activity-item-content">
              <img v-if="iscn" src="../assets/model-info1-3.png" class="activity-item animate__animated" alt="">
              <img v-else src="../assets/model-info1-3-en.png" class="activity-item-en animate__animated" alt="">
              <div v-if="iscn" class="activity-item-title">电子名片</div>
              <div v-else class="activity-item-title activity-item-title-en">Digital Business Cards</div>
              <div v-if="iscn" class="activity-item-subtitle">2023年，转转打开了赛博时代名片的新方式——电子名片！据估计，每少印刷1万张名片就能让一棵大树免于被砍伐。</div>
              <div v-else class="activity-item-subtitle">In 2023, ZhuanZhuan introduced a new way of exchanging business cards in the cyber era - digital business cards! It is estimated that for every 10,000 fewer printed business cards, one tree is spared from being cut down.</div>
            </div>
          </div>
          <div :class="['activity-item-wrap', { 'activity-item-wrap-en': !iscn }]">
            <img src="../assets/model-info1-9.png" alt="" class="activity-icon">
            <div class="activity-item-content">
              <img v-if="iscn" src="../assets/model-info1-4.png" class="activity-item animate__animated" alt="">
              <img v-else src="../assets/model-info1-4-en.png" class="activity-item-en animate__animated" alt="">
              <div v-if="iscn" class="activity-item-title">转转森林</div>
              <div v-else class="activity-item-title activity-item-title-en">ZhuanZhuan Forest</div>
              <div v-if="iscn" class="activity-item-subtitle">“转转森林”是转转环保长期主义的最佳注解。从2021年开始，转转开始积极倡导员工参与到环保活动中，在北京、深圳、青岛等地带领员工一起种树就是其中一项。2024年，共计247位转转er参与了植树，为三地转转森林共添新绿近400株，员工们以切身行动贯彻了可持续发展理念。</div>
              <div v-else class="activity-item-subtitle">"ZhuanZhuan Forest" reflects our commitment to environmental sustainability. Since 2021, we've encouraged employees to join tree planting initiatives in cities like Beijing, Shenzhen, and Qingdao. In 2024, 247 employees planted nearly 400 trees across three ZhuanZhuan Forest locations, showing their dedication to sustainability.</div>
            </div>
          </div>
          <div :class="['activity-item-wrap', { 'activity-item-wrap-en': !iscn }]">
            <img src="../assets/model-info1-9.png" alt="" class="activity-icon">
            <div class="activity-item-content">
              <img v-if="iscn" src="../assets/model-info1-5.png" class="activity-item animate__animated" alt="">
              <img v-else src="../assets/model-info1-5-en.png" class="activity-item-en animate__animated" alt="">
              <div v-if="iscn" class="activity-item-title">慈善商店</div>
              <div v-else class="activity-item-title activity-item-title-en">Charity Store</div>
              <div v-if="iscn" class="activity-item-subtitle">转转联合善淘开办了善淘慈善商店转转公益支持店，并定期捐赠物品。我们还发起了一日店长公益活动，让员工亲身参与公益，分享暖心故事。截至2024年底，已有65位转转er及家人朋友担任一日店长，累计可持续公益时长340小时，向关爱流浪动物计划、关爱认知障碍老人支援计划等公益项目捐款共11800元。</div>
              <div v-else class="activity-item-subtitle">ZhuanZhuan has partnered with ShanTao to open the ShanTao Charity Store, regularly donating items and launching a "One-Day Store Manager" charity event. By the end of 2024, 65 employees, along with their families, contributed 340 hours and raised 11,800 yuan for causes like stray animals and elderly with cognitive impairments.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.title', {
      speed: 0.5,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.sub-title', {
      speed: 0.5,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.package', {
      speed: 2,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.activity', {
      speed: 2,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 冰川图部分
            if (entry.target.classList.contains('title') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.title')?.classList?.add('fade-in')
                document.querySelector('.sub-title')?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('package') && entry.isIntersecting) {
              setTimeout(() => {
                // document.querySelector('.package-item')?.classList?.add('zoom-in')
                document.querySelectorAll('.package-item')?.forEach((item) => {
                  item?.classList?.add('zoom-in')
                })
              }, 70)
            }
            if (entry.target.classList.contains('activity') && entry.isIntersecting) {
              setTimeout(() => {
                // document.querySelector('.activity-item-content')?.classList?.add('zoom-in')
                document.querySelectorAll('.activity-item-content')?.forEach((item) => {
                  item?.classList?.add('zoom-in-fast')
                })
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.title') as Element)
      observer.observe(document.querySelector('.package') as Element)
      observer.observe(document.querySelector('.activity') as Element)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 1s 0s forwards;
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-pic {
  animation: zoomInPic 1s 0s forwards;
}

.earth-banner-up {
  animation: slideUp 0.8s 0s forwards;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  // height: 2220px;
  margin: 0 auto;
  background: #fff;
  &.content-en {
    height: 2317px;
  }
}
.wrap {
  width: 1554px;
  margin: 0 auto;
  text-align: center;
  .title{
    font-family: alibaba;
    font-weight: 1000;
    font-size: 80px;
    color: #111111;
    line-height: 80px;
    text-align: center;
    padding-top: 240px;
    padding-bottom: 120px;
    opacity: 0;
  }
  .sub-title {
    // font-family: alibaba;
    font-family: PingFang SC, PingFang SC;
    font-weight: 700;
    font-size: 36px;
    color: #111111;
    line-height: 40px;
    opacity: 0;
  }
}
.package {
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .package-item {
    width: 750px;
    height: 587px;
    opacity: 0;
  }
  .package-item-en {
    width: 750px;
    height: 623px;
  }
}
.activity {
  padding-top: 156px;
  .activity-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.activity-wrap-content {
      // margin-top: -29px;
      padding-top: 29px;
    }
    .activity-icon {
      width: 64px;
      height: 60px;
      position: absolute;
      left: 50%;
      margin-left: -32px;
      top: -29px;
      z-index: 2;
    }
    .activity-item-wrap {
      position: relative;
      width: 478px;
      height: 831px;
      flex: 0 0 478px;
    }
    .activity-item-wrap-en {
      height: 904px;
    }
    .activity-item-content {
       opacity: 0;
    }
  }

  .activity-item {
    width: 478px;
    height: 831px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .activity-item-en {
    width: 478px;
    height: 904px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .activity-item-title {
    padding-top: 480px;
    // font-family: alibaba;
    font-family: PingFang SC;
    font-weight: 700;
    font-size: 36px;
    color: #111111;
    line-height: 40px;
    text-align: center;
    position: relative;
    z-index: 2;
    // &.activity-item-title-en{
    //   font-family: alibaba2;
    // }
  }
  .activity-item-subtitle{
    padding-top: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #111111;
    line-height: 36px;
    text-align: center;
    position: relative;
    z-index: 2;
    width: 406px;
    margin: 0 auto;
    word-break: break-word;
  }
}

</style>
